import { FC } from 'react';
import styles from './next-bed-view.module.css';
import {
  BedAllocationWardListItemBedInfo,
  BedAllocationWardListItemBedState,
} from '@sqior/viewmodels/occupancy';
import { PillColor } from '../bed-view/bed-view';
import { PersonSex } from '@sqior/viewmodels/person';
import { useTextResources } from '@sqior/react/uibase';

interface NextBedViewProps {
  currentInfo: BedAllocationWardListItemBedInfo;
  nextInfo: BedAllocationWardListItemBedInfo;
  height: number;
}

const getPillColor = (sex: PersonSex) => {
  switch (sex) {
    case PersonSex.Male:
      return PillColor.Male;
    case PersonSex.Female:
      return PillColor.Female;
    default:
      return PillColor.Unisex;
  }
};

const NextBedView: FC<NextBedViewProps> = ({ currentInfo, nextInfo, height }) => {
  const textDic = useTextResources();
  if (
    currentInfo.state === BedAllocationWardListItemBedState.Occupied &&
    currentInfo.dischargeInfo?.dischargeToday &&
    (nextInfo.state === BedAllocationWardListItemBedState.Free ||
      nextInfo.state === BedAllocationWardListItemBedState.Occupied)
  ) {
    return (
      <PillWrapper sex={nextInfo.sex} height={height}>
        {textDic.get('discharge_today')}
      </PillWrapper>
    );
  }

  if (
    currentInfo.state !== BedAllocationWardListItemBedState.Blocked &&
    nextInfo.state === BedAllocationWardListItemBedState.Blocked
  ) {
    return (
      <PillWrapper sex={nextInfo.sex} height={height}>
        {textDic.get('will_be_blocked')}
      </PillWrapper>
    );
  }

  if (
    currentInfo.state === BedAllocationWardListItemBedState.Occupied &&
    !currentInfo.dischargeInfo?.dischargeToday
  )
    return null;

  if (
    currentInfo.state !== BedAllocationWardListItemBedState.Free &&
    nextInfo.state === BedAllocationWardListItemBedState.Free
  ) {
    return (
      <PillWrapper sex={nextInfo.sex} height={height}>
        {textDic.get('will_be_free')}
      </PillWrapper>
    );
  }

  return null;
};

export default NextBedView;

const PillWrapper: FC<{
  sex?: string;
  children: React.ReactNode;
  height: number;
}> = ({ sex, children, height }) => {
  return (
    <div
      className={styles['e-wrapper']}
      style={{
        backgroundColor: getPillColor(sex as PersonSex),
        height,
      }}
    >
      {children}
    </div>
  );
};
